import { Add, Remove } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  addBlog,
  checkIfDuplicateExists,
} from "../../firebase/fireStoreServices";
import BulkUploadData from "./BulkUploadData";

export default function BlogAdminForm() {
  const [blogData, setBlogData] = useState({
    title: "",
    category: "",
    date: "",
    image: "",
    points: [""],
  });

  const handleChange = (event) => {
    setBlogData({ ...blogData, [event.target.name]: event.target.value });
  };

  const handlePointChange = (index, value) => {
    const updatedPoints = [...blogData.points];
    updatedPoints[index] = value;
    setBlogData({ ...blogData, points: updatedPoints });
  };

  const removePointField = (index) => {
    const updatedPoints = blogData.points.filter((_, i) => i !== index);
    setBlogData({ ...blogData, points: updatedPoints });
  };

  const addPointField = () => {
    setBlogData({ ...blogData, points: [...blogData.points, ""] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isDuplicate = await checkIfDuplicateExists("blogs", {
        title: blogData.title,
        category: blogData.category,
        image: blogData.image,
      });

      if (isDuplicate) {
        alert("This blog is already present in the database!");
        return;
      } else {
        await addBlog(blogData); // Call your Firebase service
        alert("Blog added successfully!");
        setBlogData({
          title: "",
          category: "",
          date: "",
          image: "",
          points: [""],
        });
      }
    } catch (error) {
      console.error("Error adding blog: ", error);
      alert("Failed to add blog");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ mt: 5, p: 4, bgcolor: "#f9f9f9", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Blog Admin Form
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                name="title"
                fullWidth
                value={blogData.title}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Category"
                name="category"
                fullWidth
                value={blogData.category}
                onChange={handleChange}
                required
              />
            </Grid>{" "}
            <Grid item xs={12}>
              <TextField
                label="Date"
                name="date"
                fullWidth
                value={blogData.date}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Image URL"
                name="image"
                fullWidth
                value={blogData.image}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Points</Typography>
              {blogData.points.map((point, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <TextField
                    label={`Point ${index + 1}`}
                    fullWidth
                    value={point}
                    onChange={(e) => handlePointChange(index, e.target.value)}
                    required
                  />
                  <IconButton
                    color="error"
                    onClick={() => removePointField(index)}
                    disabled={blogData.points.length === 1}
                  >
                    <Remove />
                  </IconButton>
                  {index === blogData.points.length - 1 && (
                    <IconButton onClick={addPointField} color="success">
                      <Add />
                    </IconButton>
                  )}
                </Box>
              ))}
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="secondary">
                Add Blog
              </Button>
            </Grid>
          </Grid>
        </form>
        <Divider sx={{ mt: 3 }} />
        <BulkUploadData collectionName="blogs" uploadService={addBlog} />
      </Box>
    </Container>
  );
}
